let initialState = {
  id: null,
  api_token: null,
  name: null,
  avatar: null,
  email: null,
};

if (window.user) {
  initialState = {
    id: window.user.id,
    api_token: window.user.api_token,
    name: window.user.name,
    avatar: window.user.avatar,
    email: window.user.email,
  };
}

const state = initialState;

export default {
  namespaced: true,
  state
}
